import type { AccountInfo } from '@azure/msal-browser';

export const MAX_SESSION_MS = 8 * 60 * 60 * 1000;

interface TokenClaims {
  auth_time?: unknown;
  iat?: unknown;
}

function toEpochMs(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value * 1000;
  }

  if (typeof value === 'string') {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) {
      return parsed * 1000;
    }
  }

  return null;
}

/**
 * Epoch timestamp (ms) of the Entra sign-in event from id token claims.
 * Falls back from auth_time to iat; returns null when neither claim exists.
 */
export function sessionAnchorMs(account: AccountInfo | undefined): number | null {
  const claims = account?.idTokenClaims as TokenClaims | undefined;
  if (!claims) {
    return null;
  }

  return toEpochMs(claims.auth_time) ?? toEpochMs(claims.iat);
}

/**
 * True when the current session age exceeds the 8-hour absolute cap.
 * Missing claims fail safe to expired.
 */
export function isSessionExpired(account: AccountInfo | undefined, now = Date.now()): boolean {
  const anchor = sessionAnchorMs(account);
  if (anchor === null) {
    return true;
  }

  return now - anchor > MAX_SESSION_MS;
}
